import { Action } from '@ngrx/store';
import { LugarAtencion } from '../../models/lugarAtencion.model';

export const SET_LUGARES_ATENCION = '[lugaresAtencion] Set Lugares Atencion';
export const SET_LUGAR_ATENCION_SEARCH_TERM =
    '[prestradores] Set Lugar Atencion Search Term';
export const UNSET_LUGARES_ATENCION =
    '[lugaresAtencion] Unset Lugares Atencion';
export const SET_SINGLE_LUGAR_ATENCION =
    '[lugaresAtencion] Set Single Lugar Atencion';

export class SetLugaresAtencion implements Action {
    readonly type = SET_LUGARES_ATENCION;
    constructor(
        public lugarAtencionSeteado: {
            contenido: LugarAtencion[];
            paginado: {
                elementosTotales: number;
                paginaActual: number;
                paginasTotales: number;
            };
        }
    ) {}
}

export class UnsetLugaresAtencion implements Action {
    readonly type = UNSET_LUGARES_ATENCION;
}

export class SetLugarAtencionSearchTerm implements Action {
    readonly type = SET_LUGAR_ATENCION_SEARCH_TERM;
    constructor(
        public search: { searchTerm: string[]; searchCriteria: string[] }
    ) {}
}

export class SetSingleLugarAtencion implements Action {
    readonly type = SET_SINGLE_LUGAR_ATENCION;
    constructor(public lugarAtencionSeteado: LugarAtencion) {}
}

export type LugaresAtencionActions =
    | SetLugaresAtencion
    | UnsetLugaresAtencion
    | SetSingleLugarAtencion
    | SetLugarAtencionSearchTerm;
